import {
  Flex,
  Center,
  Box,
  FormControl,
  FormLabel,
  FormErrorMessage,
} from "@chakra-ui/react"

import useAuth from "hooks/useAuth"
import { useUI } from "providers/UIProvider"

import MainLayout from "components/templates/MainLayout"
import Heading from "components/UI/atoms/Heading"
import Input from "components/UI/atoms/Input"
import PinInput from "components/UI/atoms/PinInput"
import Button from "components/UI/atoms/Button"
import { useNavigate } from "react-router-dom"
import { useAppContext } from "providers/AppProvider/AppProvider"

const Login = () => {
  const { isAuthenticated } = useAppContext();
  const { T } = useUI();

  const navigate = useNavigate();

  if (isAuthenticated) {
    navigate("/")
  }

  const {
    otp: { sessionId, OTPValue, errorMessage, minutes, seconds },
    handleOTPChange,
    handleLoginClick,
    loading,
    form: { values, errors, touched, handleChange, handleBlur, handleSubmit },
  } = useAuth();

  return (
    <MainLayout>
      <Flex pos="absolute" left="0" top="0" w="100%" h="100%">
        <Center w="100%">
          <Box padding="45px 30px" bg="white" borderRadius="base">
            <Center>
              <Heading
                title={T("auth.login_title")}
                variant="regular"
                size="lg"
              />
            </Center>
            <Box mt="32px" typeof="form" width={374} onKeyDown={(e) => { if (e.key === "Enter") { handleSubmit() } }}>
              <FormControl
                mb="30px"
                isInvalid={Boolean(errors.phone && touched.phone)}
              >
                <FormLabel
                  htmlFor="phone"
                  fontSize="base"
                  color="main_text_color"
                >
                  {T("auth.form.phone_label")}
                </FormLabel>
                <Input
                  id="phone"
                  name="phone"
                  type="number"
                  value={values.phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  autoFocus
                  styles={{
                    width: "100%",
                    height: "50px",
                  }}
                  withButton
                  buttonProps={{
                    text: sessionId
                      ? `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`
                      : T("auth.form.send_message"),
                    onClick: handleSubmit,
                    isDisabled:
                      Boolean(!values.phone) ||
                      Boolean(errors.phone) ||
                      loading.checkAuthorizeByPhoneLoading,
                    styles: {
                      width: "155px",
                      height: "52px",
                      fontSize: "m",
                    },
                    type: "submit"
                  }}
                />
                <FormErrorMessage
                  pos="absolute"
                  width="100%"
                  bottom="-20px"
                  fontSize="base"
                >
                  {errors.phone}
                </FormErrorMessage>
              </FormControl>
            </Box>
            <Box typeof="form" onKeyDown={(e) => { if (e.key === "Enter") { handleLoginClick() } }}>
              <FormControl isInvalid={Boolean(errorMessage)}>
                <FormLabel fontSize="base" color="main_text_color">
                  {T("auth.form.sms_code")}
                </FormLabel>
                <PinInput
                  value={OTPValue}
                  onChange={(val) => handleOTPChange(val)}
                  fieldsQuantity={4}
                  isDisabled={!sessionId}
                  pinInputFieldStyles={{ width: 67, height: 50 }}
                />
                <FormErrorMessage
                  pos="absolute"
                  width="100%"
                  bottom="-20px"
                  fontSize="base"
                >
                  {errorMessage}
                </FormErrorMessage>
              </FormControl>
              <Center>
                <Button
                  mt="32px"
                  text={T("auth.form.submit_btn")}
                  onClick={handleLoginClick}
                  isDisabled={OTPValue.length !== 4}
                  isLoading={loading.authorizeByOtpLoading}
                  styles={{
                    width: "200px",
                    height: "60px",
                    fontSize: "l",
                  }}
                />
              </Center>
            </Box>
          </Box>
        </Center>
      </Flex>
    </MainLayout>
  )
}

export default Login
